const AllPhotosIcon = () => `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"
  viewBox="0 0 24 24" fill="none">
<path fill="currentColor" d="M2.7,2h7.7C10.7,2,11,2.3,11,2.7v7.7c0,0.4-0.3,0.7-0.7,0.7H2.7C2.3,11,2,10.7,2,10.3V2.7C2,2.3,2.3,2,2.7,2z"/>
<path fill="currentColor" d="M13.7,13h7.7c0.4,0,0.7,0.3,0.7,0.7v7.7c0,0.4-0.3,0.7-0.7,0.7h-7.7c-0.4,0-0.7-0.3-0.7-0.7v-7.7C13,13.3,13.3,13,13.7,13z"
 />
<path fill="currentColor" d="M13.7,2h7.7C21.7,2,22,2.3,22,2.7v7.7c0,0.4-0.3,0.7-0.7,0.7h-7.7c-0.4,0-0.7-0.3-0.7-0.7V2.7C13,2.3,13.3,2,13.7,2z"/>
<path fill="currentColor" d="M2.7,13h7.7c0.4,0,0.7,0.3,0.7,0.7v7.7c0,0.4-0.3,0.7-0.7,0.7H2.7C2.3,22,2,21.7,2,21.3v-7.7C2,13.3,2.3,13,2.7,13z"/>
</svg>`;
export default AllPhotosIcon;
